const DATA_TEST_IDS = {
  page404: 'common__page-404',
} as const;

export default DATA_TEST_IDS;
